import { ImportFileType } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { HEADER_MODIFY_TABLE_CONTENT_PROPERTY } from '@/corePagesModule/BaseTableContent/constants';
import { TableContentHeader } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';

export const contentPropertyOfMoveWarehouse: TableContentHeader = {
  contentProperties: [
    {
      key: 'warehouse',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['warehouse'], propertyType: 'string' },
    },
    {
      key: 'supplierName',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['supplierName'], propertyType: 'string' },
    },
    {
      key: 'businessNumber',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['businessNumber'], propertyType: 'string' },
    },
    {
      key: 'businessName',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['businessName'], propertyType: 'string' },
    },
    {
      key: 'package',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['package'], propertyType: 'number' },
    },
    {
      key: 'differenceOccurrenceMonthYear',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['differenceOccurrenceMonthYear'], propertyType: 'string' },
    },
    {
      key: 'differenceAmount',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['differenceAmount'], propertyType: 'number' },
    },
  ],
  options: {
    stableColumnCount: 0,
    resizableHeaderColumn: false,
  },
};

export const contentPropertyOfMoveWarehouseWithChoice: TableContentHeader = {
  contentProperties: [
    {
      key: 'choiceBusinessId',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['choiceBusinessId'], propertyType: 'string' },
    },
    ...contentPropertyOfMoveWarehouse.contentProperties,
  ],
  options: contentPropertyOfMoveWarehouse.options,
};
